export default {
    doSearchRequest({ commit }, payload){
        return new Promise((resolve, reject) => {

            const store_payload = {
                products: [
                    {
                        image: 'https://secure.img1-ag.wfcdn.com/lf/85/hash/31335/37490960/1/custom_image.jpg',
                        price: 89,
                        title: 'Tatum 6-piece basic duvet set',
                        slug: 'tatum_6_piece_basic_duvet_set',
                    },
                    {
                        image: 'https://secure.img1-ag.wfcdn.com/lf/85/hash/31335/37490960/1/custom_image.jpg',
                        price: 39,
                        title: 'Tatum 2-piece basic duvet set',
                        slug: 'tatum_2_piece_basic_duvet_set',
                    },
                    {
                        image: 'https://secure.img1-ag.wfcdn.com/lf/85/hash/31335/37490960/1/custom_image.jpg',
                        price: 149,
                        title: 'Tatum 9-piece basic duvet set',
                        slug: 'tatum_9_piece_basic_duvet_set',
                    },
                ],
                buyers_guides: [
                    {
                        title: 'Looking after your Tatum sheets',
                        slug: 'looking_after_your_tatum_sheets',
                    },
                ],
                categories: [
                    {
                        title: 'Bedding',
                        slug: 'bedding',
                    },
                    {
                        title: 'Lighting',
                        slug: 'lighting',
                    },
                ],
                brands: [
                    {
                        title: 'Oakley',
                        slug: 'oakley',
                    },
                    {
                        title: 'Honey',
                        slug: 'honey',
                    },
                ],
                search_string: null,
            }

            commit('setSearchResults', store_payload)
            resolve(store_payload)

        });        
        
    },        
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/actions/searchActions.js